const SUBFLOW_PARAMETER_PREFIX = 'subflow-';
const SHORT_NAME_SUBFLOW_INDEX = 1;
const SHORT_NAME_CALLER_INDEX = 2;
export const stateParamHasSubflow = ($stateParams) => {
    return $stateParams.shortName?.startsWith(SUBFLOW_PARAMETER_PREFIX);
};
export const getShortNameOfSubflowInParam = ($stateParams) => {
    if (!$stateParams) {
        return;
    }
    const shortNameContent = $stateParams.shortName.split('-');
    return stateParamHasSubflow($stateParams) && shortNameContent.length >= SHORT_NAME_SUBFLOW_INDEX + 1
        ? shortNameContent[SHORT_NAME_SUBFLOW_INDEX]
        : undefined;
};
export const getCallerShortNameApplicationInParam = ($stateParams) => {
    if (!$stateParams) {
        return;
    }
    const shortNameContent = $stateParams.shortName.split('-');
    return stateParamHasSubflow($stateParams) && shortNameContent.length >= SHORT_NAME_CALLER_INDEX + 1
        ? shortNameContent[SHORT_NAME_CALLER_INDEX]
        : undefined;
};
